import React from "react";
import CheckboxList from "./CheckboxList";

interface WordTemplateCheckboxListProps {
  title: string;
  readonly?: boolean;
  canBeEmpty?: boolean;
  availableTemplates: server.dto.KeyValueSublabel[];
  selectedTemplateIds: number[];
  onChanged: (selectedTemplateIds: number[]) => void;
  onSave?: () => void;
}

export const WordTemplateCheckboxList = (props: WordTemplateCheckboxListProps) => {
  return (
    <CheckboxList
      canBeEmpty={props.canBeEmpty}
      readonly={props.readonly}
      options={props.availableTemplates}
      getId={(template) => template.key}
      getTitle={(template) => template.value}
      selectedIds={props.selectedTemplateIds}
      onChange={props.onChanged}
      checkboxLabel={RESX.GeneralLabels.Visible}
      header={<>{props.title}</>}
      validatorKey="wordTemplates"
    />
  );
}